import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { DashboardMetrics } from "@cold-crew/shared";

// ─── Query Keys ───────────────────────────────────────────────────────────────

export const dashboardKeys = {
  all:     () => ["dashboard"]                        as const,
  metrics: (desde: string, hasta: string) =>
             [...dashboardKeys.all(), "metricas", desde, hasta] as const,
};

// ─── useDashboardMetrics ──────────────────────────────────────────────────────

export function useDashboardMetrics(desde: string, hasta: string) {
  return useQuery({
    queryKey: dashboardKeys.metrics(desde, hasta),
    queryFn:  () =>
      api.get<DashboardMetrics>("/dashboard/metricas", { desde, hasta }),
    staleTime: 0,
refetchOnWindowFocus: true,
  });
}

// ─── Period helpers ───────────────────────────────────────────────────────────

export function currentMonthRange(): { desde: string; hasta: string } {
  const now      = new Date();
  const year     = now.getFullYear();
  const month    = String(now.getMonth() + 1).padStart(2, "0");
  const lastDay  = new Date(year, now.getMonth() + 1, 0).getDate();
  return {
    desde: `${year}-${month}-01`,
    hasta: `${year}-${month}-${lastDay}`,
  };
}

export function previousMonthRange(): { desde: string; hasta: string } {
  const now   = new Date();
  const prev  = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const year  = prev.getFullYear();
  const month = String(prev.getMonth() + 1).padStart(2, "0");
  const last  = new Date(year, prev.getMonth() + 1, 0).getDate();
  return { desde: `${year}-${month}-01`, hasta: `${year}-${month}-${last}` };
}

export type PeriodPreset = "mes_actual" | "mes_anterior" | "ultimos_30";

export function periodFromPreset(preset: PeriodPreset): { desde: string; hasta: string } {
  if (preset === "mes_actual")   return currentMonthRange();
  if (preset === "mes_anterior") return previousMonthRange();
  // ultimos_30
  const hasta = new Date().toISOString().slice(0, 10);
  const desde = new Date(Date.now() - 29 * 86400000).toISOString().slice(0, 10);
  return { desde, hasta };
}
